import { useEffect, useState } from "react";
import "./ProfileForm.css";

export default function ProfileForm({ initialData, onSubmit, loading }) {
    const [form, setForm] = useState({
        nombres: "",
        apellidos: "",
        email: "",
        telefono: "",
        avatarUrl: "",
    });

    useEffect(() => {
        if (initialData) {
            setForm({
                nombres: initialData.nombres || "",
                apellidos: initialData.apellidos || "",
                email: initialData.email || "",
                telefono: initialData.telefono || "",
                avatarUrl: initialData.avatarUrl || "",
            });
        }
    }, [initialData]);

    const handleChange = (e) => {
        setForm((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.(form);
    };

    return (
        <form className="profile-form-card" onSubmit={handleSubmit}>
            <div className="profile-form-header">
                <div>
                    <h3>Editar perfil</h3>
                    <p>Actualiza tu información personal y de contacto.</p>
                </div>
            </div>

            <div className="profile-form-grid">
                <div className="profile-form-group">
                    <label htmlFor="nombres">Nombres</label>
                    <input
                        id="nombres"
                        name="nombres"
                        type="text"
                        placeholder="Ingresa tus nombres"
                        value={form.nombres}
                        onChange={handleChange}
                    />
                </div>

                <div className="profile-form-group">
                    <label htmlFor="apellidos">Apellidos</label>
                    <input
                        id="apellidos"
                        name="apellidos"
                        type="text"
                        placeholder="Ingresa tus apellidos"
                        value={form.apellidos}
                        onChange={handleChange}
                    />
                </div>

                <div className="profile-form-group profile-form-group-full">
                    <label htmlFor="email">Correo electrónico</label>
                    <input
                        id="email"
                        name="email"
                        type="email"
                        placeholder="correo@ejemplo.com"
                        value={form.email}
                        onChange={handleChange}
                    />
                </div>

                <div className="profile-form-group">
                    <label htmlFor="telefono">Teléfono</label>
                    <input
                        id="telefono"
                        name="telefono"
                        type="text"
                        placeholder="999 999 999"
                        value={form.telefono}
                        onChange={handleChange}
                    />
                </div>

   
            </div>

            <div className="profile-form-actions">
                <button type="submit" className="profile-form-button" disabled={loading}>
                    {loading ? "Guardando..." : "Guardar cambios"}
                </button>
            </div>
        </form>
    );
}